import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const OUTREACHS: ComboBoxItem<string>[] = [
  {
    id: 0,
    label: "Search Engine (e.g., Google, Bing)",
    value: "Search Engine (e.g., Google, Bing)",
  },
  {
    id: 1,
    label: "Social Media (e.g., LinkedIn, Twitter, Facebook)",
    value: "Social Media (e.g., LinkedIn, Twitter, Facebook)",
  },
  { id: 2, label: "Online Advertisement", value: "Online Advertisement" },
  { id: 3, label: "Word of Mouth", value: "Word of Mouth" },
  {
    id: 4,
    label: "Recommendation from a Colleague/Friend",
    value: "Recommendation from a Colleague/Friend",
  },
  { id: 5, label: "Event or Conference", value: "Event or Conference" },
  {
    id: 6,
    label: "Webinar or Online Workshop",
    value: "Webinar or Online Workshop",
  },
  { id: 7, label: "Blog or Online Article", value: "Blog or Online Article" },
  {
    id: 8,
    label: "Newsletter or Email Campaign",
    value: "Newsletter or Email Campaign",
  },
  {
    id: 9,
    label: "Startup/SME Community or Forum",
    value: "Startup/SME Community or Forum",
  },
  {
    id: 10,
    label: "Podcast or YouTube Video",
    value: "Podcast or YouTube Video",
  },
  {
    id: 11,
    label: "Tech Review or Comparison Site",
    value: "Tech Review or Comparison Site",
  },
  {
    id: 12,
    label: "Affiliate or Partner Referral",
    value: "Affiliate or Partner Referral",
  },
  {
    id: 13,
    label: "Case Study or Success Story",
    value: "Case Study or Success Story",
  },
  {
    id: 14,
    label: "Existing Customer Referral",
    value: "Existing Customer Referral",
  },
  { id: 15, label: "LinkedIn Post or Ad", value: "LinkedIn Post or Ad" },
  {
    id: 16,
    label: "Incubator or Accelerator Program",
    value: "Incubator or Accelerator Program",
  },
  {
    id: 17,
    label: "Educational Institution",
    value: "Educational Institution",
  },
  {
    id: 18,
    label: "GitHub Repository or Developer Forum",
    value: "GitHub Repository or Developer Forum",
  },
  {
    id: 19,
    label: "Cold Outreach (Email or Call)",
    value: "Cold Outreach (Email or Call)",
  },
  {
    id: 20,
    label: "Others",
    value: "Others",
  },
];

export default OUTREACHS;
